import React from "react";
import BannerSlider from "../Components/BannerSlider";
import ContactSection from "../Components/ContactSection";
import BackgroundSection from "../Components/BackgroundSection";
import VisionSection from "../Components/VisionSection";
import LatestEventsSection from "../Components/LatestEventsSection";
import NewsSection from "../Components/NewsSection";
import ProgramCalendar from "../Components/ProgramCalendar";
import MapSection from "../Components/MapSection";
import MarqueeSection from "../Components/MarqueeSection";
import ScrollToSection from "../Components/ScrollToSection";
import PraneshInstagramSlider from "../Components/PraneshInstagramSlider";

export default function HomePage() {
  return (
    <>
      <ScrollToSection />
      <MarqueeSection />
      <BannerSlider />
      <ContactSection id="complaintnow" />
      <BackgroundSection />
      <VisionSection />
      <LatestEventsSection />
      <NewsSection />
      <PraneshInstagramSlider />
      <ProgramCalendar />
      <MapSection />
    </>
  );
}
